import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useThemes } from "../../../Logic/GetStarted/useThemes";
import { useStaff } from "../../../Logic/Preference/useStaff";
import { useChangePassword } from "../../../Logic/Preference/useChangePassword";
import { useThemeSelect } from "../../../Logic/Preference/useThemeSelect";
import PreferenceCard from "../PreferenceCard";
import AddStaff from "./Components/AddStaff";
import ChangePassword from "./Components/ChangePassword";
import Style from "./PreferenceList.module.scss";
import Icon from "../../Layouts/Icons";

const PreferenceList = () => {
  const navigate = useNavigate();

  const { themeData } = useThemes();

  const { selectTheme, dropdownThemes } = useThemeSelect();

  const {
    openChangePasswordModal,
    setOpenChangePasswordModal,
    passwordValidationSchema,
    changePasswordSubmit,
    samePasswordError,
  } = useChangePassword();

  const {
    showAddStaffModal,
    setShowAddStaffModal,
    staffValidationSchema,
    staffSubmit,
  } = useStaff();

  return (
    <div className={Style.PreferenceList}>
      <PreferenceCard
        title="Studio Account"
        description="Create your account here and add relevant information"
        actionType="link"
        actions={<Icon color={"#000"} size={16} icon={"slider-nav-right"} />}
        onClick={() => navigate("/dashboard/preferences/studio")}
        hoverEffect={true}
      />
      <PreferenceCard
        title="Background Theme"
        description="Change your background theme according to your preferences"
        actionType="dropdown"
        actions={themeData}
        dropdownCurrent={dropdownThemes}
        handleClick={selectTheme}
        defaultAction="Default"
      />
      <PreferenceCard
        title="Change Password"
        description="Click here to change your password and enter your new password"
        actionType="link"
        actions="Change"
        onClick={() => setOpenChangePasswordModal(true)}
      />

      <ChangePassword
        openChangePasswordModal={openChangePasswordModal}
        setOpenChangePasswordModal={setOpenChangePasswordModal}
        passwordValidationSchema={passwordValidationSchema}
        changePasswordSubmit={changePasswordSubmit}
        samePasswordError={samePasswordError}
      />

      <AddStaff
        showAddStaffModal={showAddStaffModal}
        setShowAddStaffModal={setShowAddStaffModal}
        staffValidationSchema={staffValidationSchema}
        staffSubmit={staffSubmit}
      />
    </div>
  );
};

export default PreferenceList;
